import { useMemo } from 'react';
import Map from '../map/RxGoogleMap';
import { useFeatureFlag } from '../../hooks/use-feature-flag';
import { useContext } from './context.jsx';

export default function YieldMap() {
  const { tab, year } = useContext();
  const isCleanTab = /clean/i.test(tab);
  const isPreviewLeaf = useFeatureFlag('PreviewLeaf');
  const filters = useMemo(() => ({ year }), [year]);

  const layerConfig = useMemo(
    () =>
      [
        { id: 'corn-yield', name: 'Yield Corn' },
        { id: 'soy-yield', name: 'Yield Soy' },
        { id: 'wheat-yield', name: 'Yield Wheat' },
        {
          id: 'yield-raw',
          name: 'Yield Raw',
          filters: { convertedBy: 'AGI' },
        },
        isPreviewLeaf && {
          id: 'yield-raw-leaf',
          featureId: 'yield-raw',
          name: 'LEAF - Yield Raw',
          filters: { convertedBy: 'LEAF' },
        },
        isPreviewLeaf && { id: 'leaf-corn-yield', name: 'LEAF - Yield Corn' },
        isPreviewLeaf && { id: 'leaf-soy-yield', name: 'LEAF - Yield Soy' },
        isPreviewLeaf && { id: 'leaf-wheat-yield', name: 'LEAF - Yield Wheat' },
      ].filter(Boolean),
    [isPreviewLeaf],
  );

  const layerVisibilities = useMemo(
    () => ({
      'corn-yield': isCleanTab,
      'soy-yield': isCleanTab,
      'wheat-yield': isCleanTab,
      'yield-raw': !isCleanTab,
      'yield-raw-leaf': !isCleanTab,
    }),
    [isCleanTab],
  );

  return (
    <Map
      filters={filters}
      layers={layerConfig}
      layerVisibilities={layerVisibilities}
    />
  );
}
